/* Set the initial rating through Judge.me's own handler; never submit a review. */
(() => {
  const selector = '.jdgm-write-review-modal, .jdgm-all-reviews-widget';
  const attached = new WeakSet();

  // The store's /pages/reviews still uses Judge.me's classic, inline form.
  // Observe its widget, not the initially hidden form: Judge.me inserts the
  // form asynchronously and opens it by changing the wrapper's style.
  function attachStore(widget) {
    let handled = false;
    function initialize() {
      if (!widget.isConnected) { observer.disconnect(); return; }
      const form = widget.querySelector('.jdgm-form');
      if (!form || !form.getClientRects().length) { handled = false; return; }
      if (handled) return;
      const stars = form.querySelector('.jdgm-form__rating');
      const five = stars?.querySelector('[data-alt="5"]');
      if (!five) return;
      handled = true;
      if (!stars.querySelector('.jdgm--on, [aria-checked="true"]')) five.click();
    }
    function preserveChoice(event) {
      if (event.isTrusted && event.target.closest?.('.jdgm-form__rating')) handled = true;
    }
    widget.addEventListener('pointerdown', preserveChoice, true);
    widget.addEventListener('keydown', preserveChoice, true);
    const observer = new MutationObserver(initialize);
    observer.observe(widget, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'], childList: true, subtree: true });
    initialize();
  }

  function attach(modal) {
    if (attached.has(modal)) return;
    attached.add(modal);
    if (modal.matches('.jdgm-all-reviews-widget')) { attachStore(modal); return; }
    let handled = false;

    function initialize() {
      if (!modal.isConnected) {
        observer.disconnect();
        return;
      }
      if (getComputedStyle(modal).display === 'none' || modal.getAttribute('aria-hidden') === 'true') {
        handled = false;
        return;
      }
      if (handled || modal.getAttribute('data-current-page') !== '1') return;
      const stars = modal.querySelector('.jdgm-write-review-modal__page--review-form-intro .jdgm-write-review-modal__stars');
      const five = stars?.querySelector('button[data-alt="5"]');
      if (!five) return;
      handled = true;
      // Preserve an existing rating, including a choice made while the widget loads.
      if (!stars.querySelector('.jdgm--on')) five.click();
    }

    function preserveChoice(event) {
      if (event.isTrusted && event.target.closest?.('.jdgm-write-review-modal__stars')) handled = true;
    }
    modal.addEventListener('pointerdown', preserveChoice, true);
    modal.addEventListener('keydown', preserveChoice, true);
    const observer = new MutationObserver(initialize);
    observer.observe(modal, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden', 'data-current-page'], childList: true, subtree: true });
    initialize();
  }

  function discover(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) attach(node);
    node.querySelectorAll(selector).forEach(attach);
  }

  function start() {
    discover(document.body);
    // Judge.me appends the modal to body; watch only direct additions outside it.
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(discover)))
      .observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
